import { useState } from "react";
import { Search, FileText, BarChart3, HelpCircle, Megaphone, Heart, MessageSquare, Share2, Bookmark, Flag, ThumbsDown, ChevronDown, ChevronUp, Users, Send, Calendar, MapPin, X, Link2, Copy, Check, Compass, UserCheck, Flame } from "lucide-react";
import { Avatar, AvatarFallback } from "../ui/avatar";
import { useToast } from "../../hooks/use-toast";








const searchSuggestions = [
{ id: 1, name: "Prof. Mammadov", type: "person", uni: "Baku State University", mutuals: 12, initials: "PM" },
{ id: 2, name: "CS201 — Data Structures", type: "class", uni: "BSU", mutuals: 45, initials: "CS" },
{ id: 3, name: "Robotics Club", type: "club", uni: "ADA University", mutuals: 8, initials: "RC" },
{ id: 4, name: "Baku State University", type: "university", uni: "", mutuals: 0, initials: "BS" },
{ id: 5, name: "TechCorp Azerbaijan", type: "company", uni: "", mutuals: 3, initials: "TC" }];



const unansweredQuestions = [
{ id: 1, question: "How to solve partial differential equations with boundary conditions?", subject: "Mathematics", level: "University", author: "Tural K.", time: "3h ago" },
{ id: 2, question: "What's the difference between SN1 and SN2 reactions?", subject: "Chemistry", level: "University", author: "Aynur M.", time: "5h ago" },
{ id: 3, question: "Can anyone explain Le Chatelier's principle with real examples?", subject: "Chemistry", level: "Prep", author: "Kamran H.", time: "8h ago" }];


const communityEvents = [
{ id: 1, title: "BP Internship Fair", date: "Mar 30, 2026", location: "Villa Petrolea", source: "BP Azerbaijan", sourceType: "company", attendees: 150, type: "Career" },
{ id: 2, title: "Open Day 2026", date: "Apr 12, 2026", location: "ADA Campus", source: "ADA University", sourceType: "university", attendees: 300, type: "Open Day" },
{ id: 3, title: "Robot Wars Competition", date: "Mar 15, 2026", location: "ADA Campus", source: "Robotics Club", sourceType: "club", attendees: 45, type: "Competition" },
{ id: 4, title: "SOCAR Graduate Program 2026", date: "Apr 1, 2026", location: "Baku HQ", source: "SOCAR", sourceType: "company", attendees: 200, type: "Career" },
{ id: 5, title: "Scientific Conference 2026", date: "Mar 28, 2026", location: "BSU Main Campus", source: "Baku State University", sourceType: "university", attendees: 200, type: "Conference" }];


const myCommunities = [
{ name: "CS201 — Data Structures", type: "class" },
{ name: "Robotics Club", type: "club" },
{ name: "Baku Tech Meetup", type: "group" },
{ name: "ADA University", type: "university" }];


const composerTargets = ["Everyone", "My Class", "My University", "My Club"];

const CommunityFeed = ({ activeFilter, onOpenClass, onOpenProfile }) => {
  const [composerOpen, setComposerOpen] = useState(false);
  const [composerType, setComposerType] = useState(null);
  const [composerTarget, setComposerTarget] = useState("Everyone");
  const [searchQuery, setSearchQuery] = useState("");
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [feedTab, setFeedTab] = useState("discover");
  const [liked, setLiked] = useState({ 2: true });
  const [disliked, setDisliked] = useState({});
  const [saved, setSaved] = useState([]);
  const [followed, setFollowed] = useState([]);
  const [showUnanswered, setShowUnanswered] = useState(true);
  const [showEvents, setShowEvents] = useState(true);
  const [eventFilter, setEventFilter] = useState("all");
  const [replyingTo, setReplyingTo] = useState(null);
  const [replyText, setReplyText] = useState("");
  const [shareEventId, setShareEventId] = useState(null);
  const [linkCopied, setLinkCopied] = useState(false);
  const { toast } = useToast();

  const filteredEvents = communityEvents.filter((e) =>
  eventFilter === "all" || e.sourceType === eventFilter
  );

  const toggleLike = (id) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
    if (disliked[id]) setDisliked((prev) => ({ ...prev, [id]: false }));
  };

  const toggleDislike = (id) => {
    setDisliked((prev) => ({ ...prev, [id]: !prev[id] }));
    if (liked[id]) setLiked((prev) => ({ ...prev, [id]: false }));
  };

  const toggleSave = (id) => {
    const isSaved = saved.includes(id);
    setSaved((prev) => isSaved ? prev.filter((s) => s !== id) : [...prev, id]);
    toast({ title: isSaved ? "Removed from saved" : "Post saved" });
  };

  const toggleFollow = (authorId, authorName) => {
    const isFollowed = followed.includes(authorId);
    setFollowed((prev) => isFollowed ? prev.filter((f) => f !== authorId) : [...prev, authorId]);
    toast({
      title: isFollowed ? `Unfollowed ${authorName}` : `You are now following ${authorName}`,
      description: isFollowed ? undefined : "You'll see their posts in your feed."
    });
  };

  const filteredSearch = searchQuery.length > 1 ?
  searchSuggestions.filter((s) => s.name.toLowerCase().includes(searchQuery.toLowerCase())) :
  [];

  return (
    <div className="space-y-4">
      {/* Search with Autocomplete */}
      <div className="stat-card !p-3 relative">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <input
            value={searchQuery}
            onChange={(e) => {setSearchQuery(e.target.value);setShowSearchResults(true);}}
            onFocus={() => setShowSearchResults(true)}
            onBlur={() => setTimeout(() => setShowSearchResults(false), 200)}
            placeholder="Search people, universities, clubs, classes..."
            className="w-full pl-10 pr-4 py-2.5 rounded-xl bg-muted border-0 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring" />
          
        </div>
        {/* Autocomplete dropdown */}
        {showSearchResults && filteredSearch.length > 0 &&
        <div className="absolute top-full left-0 right-0 mt-1 z-30 bg-card rounded-2xl border border-border shadow-xl overflow-hidden animate-fade-in">
            {filteredSearch.map((s) =>
          <button key={s.id}
          onClick={() => {
            if (s.type === "class") onOpenClass?.(s.id);else
            if (s.type === "person") onOpenProfile?.(s.id);
            setSearchQuery("");
            setShowSearchResults(false);
          }}
          className="w-full flex items-center gap-3 px-4 py-2.5 hover:bg-muted transition-colors text-left">
            
                <Avatar className="w-8 h-8">
                  <AvatarFallback className="bg-primary/10 text-primary text-[10px] font-bold">{s.initials}</AvatarFallback>
                </Avatar>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground">{s.name}</p>
                  <p className="text-[10px] text-muted-foreground capitalize">{s.type}{s.uni ? ` · ${s.uni}` : ""}{s.mutuals > 0 ? ` · ${s.mutuals} mutual` : ""}</p>
                </div>
                {s.type === "person" &&
            <span className="text-[10px] px-2 py-0.5 rounded-full bg-secondary/10 text-secondary font-medium">Follow</span>
            }
                {s.type === "class" &&
            <span className="text-[10px] px-2 py-0.5 rounded-full bg-primary/10 text-primary font-medium">Join</span>
            }
              </button>
          )}
          </div>
        }
      </div>

      {/* Composer */}
      <div className="stat-card !p-4">
        <div className="flex items-center gap-3 mb-3">
          <Avatar className="w-9 h-9">
            <AvatarFallback className="bg-secondary text-secondary-foreground text-xs font-bold">AA</AvatarFallback>
          </Avatar>
          <button
            onClick={() => setComposerOpen(!composerOpen)}
            className="flex-1 text-left px-4 py-2.5 rounded-xl bg-muted text-sm text-muted-foreground hover:bg-muted/80 transition-colors">
            
            Share something with the community...
          </button>
        </div>
        {composerOpen &&
        <div className="space-y-3 border-t border-border pt-3 animate-fade-in">
            {/* Composer type buttons */}
            <div className="flex flex-wrap gap-2">
              {[
            { id: "resource", icon: FileText, label: "Share Resource" },
            { id: "poll", icon: BarChart3, label: "Create Poll" },
            { id: "question", icon: HelpCircle, label: "Ask Question" },
            { id: "announcement", icon: Megaphone, label: "Announcement" }].
            map((t) =>
            <button key={t.id} onClick={() => setComposerType(composerType === t.id ? null : t.id)}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
            composerType === t.id ? "bg-secondary/15 text-secondary" : "bg-muted hover:bg-secondary/10 text-muted-foreground hover:text-secondary"}`
            }>
                  <t.icon className="w-3.5 h-3.5" /> {t.label}
                </button>
            )}
            </div>

            {/* Composer textarea */}
            <textarea
            className="w-full p-3 rounded-xl bg-muted border-0 text-sm text-foreground placeholder:text-muted-foreground resize-none h-20 focus:outline-none focus:ring-2 focus:ring-ring"
            placeholder={
            composerType === "resource" ? "Describe the resource you're sharing..." :
            composerType === "poll" ? "Write your poll question..." :
            composerType === "question" ? "Ask your question... use @ to tag someone" :
            composerType === "announcement" ? "Write your announcement..." :
            "What's on your mind?"
            } />
          

            {/* Target audience selector */}
            {composerType === "announcement" &&
          <div className="flex items-center gap-2">
                <span className="text-xs text-muted-foreground">Target:</span>
                {composerTargets.map((t) =>
            <button key={t} onClick={() => setComposerTarget(t)}
            className={`text-xs px-2.5 py-1 rounded-full font-medium transition-colors ${
            composerTarget === t ? "bg-secondary/15 text-secondary" : "bg-muted text-muted-foreground hover:bg-muted/80"}`
            }>
                    {t}
                  </button>
            )}
              </div>
          }

            {/* Poll options preview */}
            {composerType === "poll" &&
          <div className="space-y-1.5">
                {["Option A", "Option B", "Option C"].map((opt, i) =>
            <input key={i} placeholder={opt}
            className="w-full px-3 py-2 rounded-lg bg-card border border-border text-xs text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring" />

            )}
                <button className="text-xs text-secondary font-medium hover:underline">+ Add option</button>
              </div>
          }

            <div className="flex items-center justify-between">
              <div className="flex items-center gap-1">
                {composerType === "resource" &&
              <button className="px-3 py-1.5 rounded-lg bg-muted text-xs text-muted-foreground hover:text-foreground transition-colors flex items-center gap-1">
                    <FileText className="w-3 h-3" /> Attach PDF
                  </button>
              }
              </div>
              <button className="px-4 py-2 rounded-xl bg-primary text-primary-foreground text-xs font-semibold hover:bg-primary/90 transition-colors flex items-center gap-1">
                <Send className="w-3.5 h-3.5" /> Post
              </button>
            </div>
          </div>
        }
      </div>

      {/* Unanswered Questions */}
      <div className="stat-card !p-4">
        <button onClick={() => setShowUnanswered(!showUnanswered)} className="w-full flex items-center justify-between mb-2">
          <h3 className="section-title text-base flex items-center gap-2">
            <HelpCircle className="w-4 h-4 text-secondary" />
            Unanswered Questions — help your peers
          </h3>
          {showUnanswered ? <ChevronUp className="w-4 h-4 text-muted-foreground" /> : <ChevronDown className="w-4 h-4 text-muted-foreground" />}
        </button>
        {showUnanswered &&
        <div className="space-y-2">
            {unansweredQuestions.map((q) =>
          <div key={q.id} className="flex items-start gap-3 p-3 rounded-xl bg-muted/50 hover:bg-muted transition-colors">
                <HelpCircle className="w-4 h-4 text-secondary mt-0.5 flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-foreground font-medium line-clamp-1">{q.question}</p>
                  <div className="flex items-center gap-2 mt-1 text-xs text-muted-foreground">
                    <span className="px-2 py-0.5 rounded-full bg-secondary/10 text-secondary font-medium">{q.subject}</span>
                    <span>{q.level}</span>
                    <span>by {q.author}</span>
                    <span>{q.time}</span>
                  </div>
                </div>
                <button className="px-3 py-1.5 rounded-lg bg-secondary text-secondary-foreground text-xs font-semibold hover:bg-secondary/90 transition-colors flex-shrink-0">
                  Answer
                </button>
              </div>
          )}
          </div>
        }
      </div>

      {/* Discover Events */}
      <div className="stat-card !p-4">
        <button onClick={() => setShowEvents(!showEvents)} className="w-full flex items-center justify-between mb-2">
          <h3 className="section-title text-base flex items-center gap-2">
            <Calendar className="w-4 h-4 text-secondary" />
            Discover Events
          </h3>
          {showEvents ? <ChevronUp className="w-4 h-4 text-muted-foreground" /> : <ChevronDown className="w-4 h-4 text-muted-foreground" />}
        </button>
        {showEvents &&
        <>
            <div className="flex gap-1 mb-3 flex-wrap">
              {[
            { id: "all", label: "All" },
            { id: "company", label: "Companies" },
            { id: "university", label: "Universities" },
            { id: "club", label: "Clubs" }].
            map((f) =>
            <button key={f.id} onClick={() => setEventFilter(f.id)}
            className={`text-xs px-2.5 py-1 rounded-lg font-medium transition-colors ${
            eventFilter === f.id ? "bg-secondary/15 text-secondary" : "text-muted-foreground hover:bg-muted"}`
            }>
                  {f.label}
                </button>
            )}
            </div>
            <div className="space-y-2">
              {filteredEvents.map((event) =>
            <div key={event.id} className="flex items-start gap-3 p-3 rounded-xl bg-muted/50 hover:bg-muted transition-colors">
                  <div className="w-10 h-10 rounded-xl bg-secondary/10 flex flex-col items-center justify-center flex-shrink-0">
                    <Calendar className="w-3.5 h-3.5 text-secondary mb-0.5" />
                    <span className="text-[7px] font-bold text-secondary">{event.date.split(",")[0].split(" ").slice(0, 2).join(" ")}</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm font-medium text-foreground">{event.title}</h4>
                    <div className="flex items-center gap-2 mt-0.5 text-xs text-muted-foreground">
                      <span className="px-1.5 py-0.5 rounded-md bg-primary/10 text-primary font-medium text-[10px]">{event.source}</span>
                      <span className="flex items-center gap-0.5"><MapPin className="w-3 h-3" />{event.location}</span>
                    </div>
                    <p className="text-[10px] text-muted-foreground mt-0.5">{event.date} · {event.attendees} attending</p>
                  </div>
                  <div className="flex flex-col gap-1 flex-shrink-0">
                    <button className="px-2.5 py-1 rounded-lg bg-primary text-primary-foreground text-[10px] font-semibold hover:bg-primary/90 transition-colors">
                      Attend
                    </button>
                    <button onClick={() => setShareEventId(event.id)}
                className="px-2.5 py-1 rounded-lg bg-muted text-[10px] font-medium text-muted-foreground hover:text-foreground transition-colors flex items-center gap-0.5 justify-center">
                      <Share2 className="w-3 h-3" /> Share
                    </button>
                  </div>
                </div>
            )}
            </div>
          </>
        }
      </div>

      {/* Share to Community Modal */}
      {shareEventId && (() => {
        const event = communityEvents.find((e) => e.id === shareEventId);
        if (!event) return null;
        const link = `https://yeniders.app/event/${event.id}`;
        return (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setShareEventId(null)}>
            <div className="absolute inset-0 bg-foreground/40 backdrop-blur-sm" />
            <div className="relative bg-card rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden animate-fade-in" onClick={(e) => e.stopPropagation()}>
              <div className="flex items-center justify-between px-5 py-4 border-b border-border">
                <h3 className="font-display font-bold text-foreground text-sm flex items-center gap-2">
                  <Share2 className="w-4 h-4 text-secondary" /> Share Event
                </h3>
                <button onClick={() => setShareEventId(null)} className="w-7 h-7 rounded-lg hover:bg-muted flex items-center justify-center">
                  <X className="w-4 h-4" />
                </button>
              </div>
              <div className="p-5 space-y-4">
                <div className="p-3 rounded-xl bg-muted/50">
                  <p className="text-sm font-semibold text-foreground">{event.title}</p>
                  <p className="text-xs text-muted-foreground mt-0.5">{event.source} · {event.date}</p>
                </div>

                {/* Copy link */}
                <div>
                  <p className="text-xs font-medium text-foreground mb-1.5">Copy link</p>
                  <div className="flex items-center gap-2 p-2.5 rounded-xl bg-muted">
                    <Link2 className="w-4 h-4 text-muted-foreground flex-shrink-0" />
                    <span className="text-[10px] text-muted-foreground truncate flex-1">{link}</span>
                    <button onClick={() => {navigator.clipboard.writeText(link);setLinkCopied(true);setTimeout(() => setLinkCopied(false), 2000);}}
                    className={`px-2 py-1 rounded-lg text-[10px] font-semibold flex items-center gap-1 ${
                    linkCopied ? "bg-secondary text-secondary-foreground" : "bg-primary/10 text-primary hover:bg-primary/20"}`
                    }>
                      {linkCopied ? <><Check className="w-3 h-3" /> Copied</> : <><Copy className="w-3 h-3" /> Copy</>}
                    </button>
                  </div>
                </div>

                {/* Share to community */}
                <div>
                  <p className="text-xs font-medium text-foreground mb-1.5">Suggest to your community</p>
                  <div className="space-y-1.5">
                    {myCommunities.map((c, i) =>
                    <button key={i} onClick={() => {toast({ title: `Shared to ${c.name}`, description: "Your community will see this event." });setShareEventId(null);}}
                    className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl bg-muted/50 hover:bg-muted text-left transition-colors">
                        <Users className="w-3.5 h-3.5 text-muted-foreground" />
                        <span className="text-xs font-medium text-foreground flex-1">{c.name}</span>
                        <span className="text-[9px] px-1.5 py-0.5 rounded-full bg-primary/10 text-primary font-medium capitalize">{c.type}</span>
                        <span className="text-[10px] text-secondary font-medium">Share</span>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>);

      })()}


    </div>);

};

export default CommunityFeed;